module.exports = __webpack_public_path__ + "assets/benefits-email-5218ad.svg";